export default function BurgerDemo() {
  return (
    <div style={{ padding: "40px" }}>
      <h1>Burger House Demo</h1>
      <p>Template de restaurante.</p>
    </div>
  );
}
